import React, { useEffect, useState } from 'react';
import CustomInput from '../custom-input/custom-input.component';
import InputLabel from '@mui/material/InputLabel';
import Input from '@mui/material/Input';
import FormError from '../form-error/form-error.component';
import { useTranslation } from 'react-i18next';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { ErrorMessage } from '@hookform/error-message';
import { Controller, useFormContext } from 'react-hook-form';
import { EMAIL_REGEX } from 'util/constants';

const InputEmailOrPhone = ({ name, label, defaultValue }) => {
  const { control, resetField } = useFormContext();
  const { t } = useTranslation();
  const [displayValue, setDisplayValue] = useState(defaultValue);

  useEffect(() => {
    resetField(name, { defaultValue });
    setDisplayValue(defaultValue);
  }, [defaultValue, name, resetField]);

  const validate = value => {
    if (value.includes('@')) {
      return (
        EMAIL_REGEX.test(value.trim()) || t('forms.errors.emailOrPhone.invalid')
      );
    }
    const parsed = parsePhoneNumberFromString(value, 'US');
    return (
      (parsed && parsed.isPossible()) || t('forms.errors.emailOrPhone.invalid')
    );
  };

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={defaultValue}
      rules={{
        required: t('register.errors.requiredField'),
        validate,
      }}
      render={({
        field: { onChange, ref, value, ...fieldRest },
        formState: { errors },
      }) => (
        <CustomInput>
          <InputLabel htmlFor={name}>{label}*</InputLabel>
          <Input
            id={name}
            fullWidth
            onChange={event => {
              const raw = event.target.value;
              if (!raw.includes('@')) {
                const parsed = parsePhoneNumberFromString(raw, 'US');
                if (parsed) {
                  if (parsed.nationalNumber.length > 10) return;
                  if (parsed.nationalNumber.length === 10) {
                    setDisplayValue(parsed.formatNational());
                    onChange(parsed.nationalNumber);
                    return;
                  }
                }
              }
              setDisplayValue(raw);
              onChange(raw);
            }}
            inputRef={ref}
            error={!!errors[name]}
            inputProps={{ 'aria-required': true }}
            placeholder={label}
            aria-describedby="FormError"
            {...fieldRest}
            value={displayValue}
          />
          <ErrorMessage
            name={name}
            errors={errors}
            render={({ message }) => (
              <FormError
                errorMessage={message}
                data-testid="InputEmailOrPhone.FormError"
              />
            )}
          />
        </CustomInput>
      )}
    />
  );
};

export default InputEmailOrPhone;
